<template>
  <div>
    <div class="rule">
      <div class="ruleTitle"></div>
      <div class="rules"></div>
    </div>
  </div>
</template>

<script>
  export default{
    data(){
      return{

      }
    },
    created() {

    },
    mounted() {

    },
    methods:{

    }
  }
</script>

<style>
  .rule{
    width: calc(100% - 40px);
    margin: 20px;
    
  }
  .ruleTitle{
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 20px;
  }
  .rules{
    width: 100%;
    display: flex;
    align-items: center;
    font-size: 14px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/account/rule.vue